import React from 'react';
import Tabs from '../components/common/Tab/Tabs';

const AccessDenied: React.FC = () => {
  return (
    <div>
      <Tabs />
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h1>アクセス権限がありません</h1>
        <p>このページを表示する権限がありません。</p>
      </div>
    </div>
  );
};

export default AccessDenied;